export const faqContentTranslations = {
  // 问题1
  "faq1Question": {
    en: "What documents do I need to enter Malaysia?",
    zh: "进入马来西亚需要哪些文件？"
  },
  "faq1AnswerIntro": {
    en: "For most visitors, you'll need:",
    zh: "对于大多数游客，您需要："
  },
  "faq1AnswerItem1": {
    en: "A valid passport with at least 6 months validity",
    zh: "有效期至少6个月的有效护照"
  },
  "faq1AnswerItem2": {
    en: "Return or onward tickets",
    zh: "返程或继续行程的票"
  },
  "faq1AnswerItem3": {
    en: "Sufficient funds for your stay",
    zh: "足够的停留资金"
  },
  "faq1AnswerItem4": {
    en: "Visa (if required for your nationality)",
    zh: "签证（如果您的国籍需要）"
  },
  "faq1AnswerOutro": {
    en: "Always check the latest requirements with the Malaysian embassy or consulate in your country before traveling.",
    zh: "旅行前务必向您所在国家的马来西亚大使馆或领事馆查询最新要求。"
  },

  // 问题2
  "faq2Question": {
    en: "Do I need a visa to visit Penang?",
    zh: "访问槟城需要签证吗？"
  },
  "faq2Answer": {
    en: "It depends on your nationality. Many countries have visa-free arrangements with Malaysia for short stays (typically 30-90 days). Check with the Malaysian embassy or consulate in your country for specific requirements.",
    zh: "这取决于您的国籍。许多国家与马来西亚有短期停留（通常为30-90天）的免签协议。请向您所在国家的马来西亚大使馆或领事馆咨询具体要求。"
  },

  // 问题3
  "faq3Question": {
    en: "How do I apply for a student visa for Malaysia?",
    zh: "如何申请马来西亚学生签证？"
  },
  "faq3Answer": {
    en: "Student visas are typically arranged through your educational institution in Malaysia. After receiving an offer letter, the institution will apply for a Student Pass on your behalf through EMGS (Education Malaysia Global Services). You'll need to provide documents like your passport, photos, academic certificates, and health examination results.",
    zh: "学生签证通常通过您在马来西亚的教育机构安排。收到录取通知书后，该机构将通过EMGS（马来西亚教育全球服务）代表您申请学生通行证。您需要提供护照、照片、学历证书和健康检查结果等文件。"
  },

  // 问题4
  "faq4Question": {
    en: "What are the best areas to stay in Penang?",
    zh: "槟城最好的住宿区域有哪些？"
  },
  "faq4AnswerIntro": {
    en: "Popular areas include:",
    zh: "热门区域包括："
  },
  "faq4AnswerItem1": {
    en: "Georgetown - Historic center, great for culture and food",
    zh: "乔治市 - 历史中心，文化和美食的绝佳地点"
  },
  "faq4AnswerItem2": {
    en: "Batu Ferringhi - Beach area with resorts",
    zh: "峇都丁宜 - 拥有度假村的海滩区"
  },
  "faq4AnswerItem3": {
    en: "Tanjung Bungah - Residential area between Georgetown and Batu Ferringhi",
    zh: "丹绒武雅 - 位于乔治市和峇都丁宜之间的住宅区"
  },
  "faq4AnswerItem4": {
    en: "Gurney - Upscale area with shopping and dining",
    zh: "格尼 - 拥有购物和餐饮的高档区域"
  },
  "faq4AnswerItem5": {
    en: "Bayan Lepas - Near the airport and industrial zone",
    zh: "峇六拜 - 靠近机场和工业区"
  },
  "faq4AnswerOutro": {
    en: "Your ideal location depends on your preferences, budget, and purpose of stay.",
    zh: "您的理想位置取决于您的偏好、预算和停留目的。"
  },

  // 问题5
  "faq5Question": {
    en: "How do I get from Penang International Airport to Georgetown?",
    zh: "如何从槟城国际机场到乔治市？"
  },
  "faq5Answer": {
    en: "You have several options: 1) Taxi/Grab - most convenient, costs around RM25-30, takes about 30 minutes. 2) Bus - Route 401E goes directly to Georgetown, costs RM2-3, takes about 45-60 minutes. 3) Airport shuttle - available to major hotels. 4) Car rental - available at the airport if you prefer to drive yourself.",
    zh: "您有几种选择：1) 出租车/Grab - 最方便，费用约为25-30林吉特，需时约30分钟。2) 巴士 - 401E路线直接前往乔治市，费用为2-3林吉特，需时约45-60分钟。3) 机场班车 - 提供前往主要酒店的服务。4) 租车 - 如果您想自己开车，机场有租车服务。"
  },

  // 问题6
  "faq6Question": {
    en: "What public transportation options are available in Penang?",
    zh: "槟城有哪些公共交通选择？"
  },
  "faq6AnswerIntro": {
    en: "Penang offers several public transportation options:",
    zh: "槟城提供多种公共交通选择："
  },
  "faq6AnswerItem1": {
    en: "Rapid Penang buses - Extensive network covering most of the island",
    zh: "槟城快速巴士 - 覆盖岛上大部分地区的广泛网络"
  },
  "faq6AnswerItem2": {
    en: "Free CAT buses - In Georgetown area",
    zh: "免费CAT巴士 - 在乔治市区域"
  },
  "faq6AnswerItem3": {
    en: "Grab - Popular ride-hailing service",
    zh: "Grab - 受欢迎的网约车服务"
  },
  "faq6AnswerItem4": {
    en: "Taxis - Available throughout the island",
    zh: "出租车 - 全岛均有提供"
  },
  "faq6AnswerItem5": {
    en: "Bicycle rentals - Popular in Georgetown",
    zh: "自行车租赁 - 在乔治市很受欢迎"
  },
  "faq6AnswerItem6": {
    en: "Trishaw - Traditional option for short distances in Georgetown",
    zh: "三轮车 - 乔治市短距离的传统选择"
  },

  // 问题7
  "faq7Question": {
    en: "How do I open a bank account in Malaysia as a foreigner?",
    zh: "作为外国人，如何在马来西亚开设银行账户？"
  },
  "faq7Answer": {
    en: "To open a bank account, visit a bank branch with your passport, visa/permit, proof of address in Malaysia (rental agreement or utility bill), and reference letter (sometimes required). Popular banks include Maybank, CIMB, and Public Bank. Requirements may vary between banks, so it's advisable to call ahead.",
    zh: "要开设银行账户，请携带您的护照、签证/许可证、马来西亚地址证明（租赁协议或水电费账单）以及推荐信（有时需要）前往银行网点。受欢迎的银行包括马来亚银行、联昌国际银行和大众银行。各银行的要求可能有所不同，建议提前致电咨询。"
  },

  // 问题8
  "faq8Question": {
    en: "What are the must-visit attractions in Penang?",
    zh: "槟城必须参观的景点有哪些？"
  },
  "faq8AnswerIntro": {
    en: "Top attractions in Penang include:",
    zh: "槟城的顶级景点包括："
  },
  "faq8AnswerItem1": {
    en: "Georgetown's UNESCO Heritage Zone",
    zh: "乔治市的联合国教科文组织遗产区"
  },
  "faq8AnswerItem2": {
    en: "Penang Hill",
    zh: "槟城山"
  },
  "faq8AnswerItem3": {
    en: "Kek Lok Si Temple",
    zh: "极乐寺"
  },
  "faq8AnswerItem4": {
    en: "Batu Ferringhi Beach",
    zh: "峇都丁宜海滩"
  },
  "faq8AnswerItem5": {
    en: "Penang National Park",
    zh: "槟城国家公园"
  },
  "faq8AnswerItem6": {
    en: "Tropical Spice Garden",
    zh: "热带香料花园"
  },
  "faq8AnswerItem7": {
    en: "Penang Street Art",
    zh: "槟城街头艺术"
  },
  "faq8AnswerItem8": {
    en: "Clan Jetties",
    zh: "宗族码头"
  },
  "faq8AnswerItem9": {
    en: "Pinang Peranakan Mansion",
    zh: "槟榔屿娘惹博物馆"
  },
  "faq8AnswerItem10": {
    en: "Entopia (Butterfly Farm)",
    zh: "Entopia（蝴蝶农场）"
  },

  // 问题9
  "faq9Question": {
    en: "Where can I find the best local food in Penang?",
    zh: "在槟城哪里可以找到最好的当地美食？"
  },
  "faq9Answer": {
    en: "Penang is famous for its street food. Visit hawker centers like Gurney Drive Hawker Centre, New Lane Hawker Centre, and Cecil Street Market. For specific dishes, try Char Koay Teow at Lorong Selamat, Assam Laksa at Air Itam Market, and Cendol at Penang Road. Georgetown has numerous food options ranging from street stalls to upscale restaurants.",
    zh: "槟城以其街头美食而闻名。参观格尼道小贩中心、新巷小贩中心和义兴街市场等小贩中心。对于特定菜肴，可以在Lorong Selamat尝试炒粿条，在亚依淡市场尝试亚参叻沙，在槟城路尝试煎蕊。乔治市有众多美食选择，从街头摊位到高档餐厅应有尽有。"
  },

  // 问题10
  "faq10Question": {
    en: "What healthcare facilities are available for foreigners in Penang?",
    zh: "槟城有哪些医疗设施可供外国人使用？"
  },
  "faq10Answer": {
    en: "Penang has excellent healthcare facilities with several private hospitals that cater to international patients, including Penang Adventist Hospital, Gleneagles Penang, Island Hospital, and Loh Guan Lye Specialists Centre. These hospitals have English-speaking staff and modern facilities. For minor issues, there are numerous clinics throughout the island.",
    zh: "槟城拥有优秀的医疗设施，有几家私立医院专门为国际患者提供服务，包括槟城复临医院、槟城鹰阁医院、槟岛医院和陆源泰专科中心。这些医院拥有说英语的工作人员和现代化设施。对于轻微问题，岛上有众多诊所。"
  },

  // 问题11
  "faq11Question": {
    en: "How can I get a local SIM card and mobile service in Penang?",
    zh: "在槟城如何获取当地SIM卡和移动服务？"
  },
  "faq11Answer": {
    en: "You can purchase a local SIM card at the airport, convenience stores, or provider shops. Major providers include Maxis, Celcom, Digi, and U Mobile. Bring your passport for registration. Tourist SIM packages typically offer data, calls, and texts for 7-30 days at affordable rates. Most areas in Penang have good 4G coverage.",
    zh: "您可以在机场、便利店或供应商商店购买当地SIM卡。主要供应商包括Maxis、Celcom、Digi和U Mobile。携带护照进行注册。旅游SIM卡套餐通常以实惠的价格提供7-30天的数据、通话和短信服务。槟城大多数地区都有良好的4G覆盖。"
  }
};
